// src/config/menuPermissions.js - Versión dinámica
// Solo helpers de presentación. NADA de permisos hardcodeados.

/**
 * Convierte un ID de rol o nombre a un texto legible.
 * Acepta: ID numérico, nombre con guiones, nombre con espacios, mayúsculas, etc.
 * 
 * @param {number|string} roleKey - ID o nombre del rol
 * @returns {string} Nombre formateado
 * 
 * Ejemplos:
 *   getRoleDisplayName(1)                      → "Super Administrador"
 *   getRoleDisplayName('super_administrador')  → "Super Administrador"
 *   getRoleDisplayName('tecnico')              → "Técnico"
 *   getRoleDisplayName('TECNICO')              → "Técnico"
 */
export const getRoleDisplayName = (roleKey) => {
  if (roleKey === undefined || roleKey === null || roleKey === '') {
    return 'Usuario';
  }

  // Mapa de ID → nombre legible
  const ID_MAP = {
    1: 'Super Administrador',
    2: 'Administrador',
    3: 'Supervisor',
    4: 'Vendedor',
    5: 'Técnico',
    6: 'Pasante',
    7: 'Almacenista',
    8: 'Cobrador'
  };

  // Mapa de nombre → nombre legible (para casos especiales)
  const NAME_MAP = {
    'super_administrador': 'Super Administrador',
    'super administrador': 'Super Administrador',
    'superadmin': 'Super Administrador',
    'administrador': 'Administrador',
    'admin': 'Administrador',
    'tecnico': 'Técnico',
    'técnico': 'Técnico',
    'vendedor': 'Vendedor',
    'almacenista': 'Almacenista',
    'almacen': 'Almacenista',
    'cobrador': 'Cobrador',
    'caja': 'Cajero',
    'supervisor': 'Supervisor',
    'pasante': 'Pasante'
  };

  // Si es número o string numérico → buscar en ID_MAP
  const numId = parseInt(roleKey);
  if (!isNaN(numId) && ID_MAP[numId]) {
    return ID_MAP[numId];
  }

  // Si es string → normalizar y buscar en NAME_MAP
  const key = roleKey.toString().toLowerCase().trim().replace(/-/g, '_');
  if (NAME_MAP[key]) {
    return NAME_MAP[key];
  }

  // Fallback: capitalizar el string tal cual
  return roleKey
    .toString()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
};

export default {
  getRoleDisplayName
};